import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getRecommendedComics } from '@/mocks/comics';

export default function RecommendedSection() {
  const recommended = getRecommendedComics();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
              <i className="ri-thumb-up-line text-background-50 text-sm"></i>
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                编辑精选
              </h2>
              <p className="text-xs text-foreground-500 mt-0.5">编辑部精心挑选的优质作品</p>
            </div>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {recommended.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="large" />
          ))}
        </div>
      </div>
    </section>
  );
}